export default __webpack_public_path__ + "static/media/image-watermark-random.046569a7.gif";